import { useCallback, useState } from 'react';

interface UploadZoneProps {
  onFileSelect: (file: File) => void;
}

export default function UploadZone({ onFileSelect }: UploadZoneProps) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setIsDragging(false);
      const file = e.dataTransfer.files[0];
      if (file && (file.name.endsWith('.glb') || file.name.endsWith('.gltf'))) {
        onFileSelect(file);
      } else {
        alert('Please drop a .glb or .gltf file');
      }
    },
    [onFileSelect],
  );

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) onFileSelect(file);
    },
    [onFileSelect],
  );

  return (
    <label
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
        padding: '2rem',
        border: `2px dashed ${isDragging ? 'var(--accent)' : '#475569'}`,
        borderRadius: '0.75rem',
        background: 'var(--panel)',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease',
      }}
    >
      <input type="file" accept=".glb,.gltf" onChange={handleChange} style={{ display: 'none' }} />
      <span style={{ fontSize: '2rem' }}>📦</span>
      <span>Drop a GLB/glTF file here or click to browse</span>
      <span style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>Supports .glb and .gltf</span>
    </label>
  );
}
